import { SYSTEM } from "@thi.ng/random";
import { randMinMax } from "@thi.ng/vectors";
import { bounds } from "./bounds";
import { pointInside } from "./point-inside";
export const scatter = (shape, num, rnd = SYSTEM, out = []) => {
    const b = bounds(shape);
    if (!b)
        return;
    const mi = b.pos;
    const mx = b.max();
    for (; --num >= 0;) {
        while (true) {
            const p = randMinMax([], mi, mx, rnd);
            if (pointInside(shape, p)) {
                out.push(p);
                break;
            }
        }
    }
    return out;
};
